"use client"

import { checkDoNotTrack, isOptedOut, trackEvent } from "@remcostoeten/analytics"
import { publicEnv } from "@zentjes/config"

type EventMeta = Record<string, string | number | boolean | null | undefined>

const DEFAULT_INGEST_URL = "http://localhost:6967"
const REMCOSTETEN_INGEST_URL = "https://ingestion.remcostoeten.nl"

function isRemcoHost(): boolean {
  if (typeof window === "undefined") return false
  const host = window.location.hostname
  return (
    host.includes("remcostoeten.nl") ||
    host.includes("localhost") ||
    host === "zentjes.com"
  )
}

const _ingestUrl = publicEnv.NEXT_PUBLIC_INGEST_URL ?? (isRemcoHost() ? REMCOSTETEN_INGEST_URL : DEFAULT_INGEST_URL)
export const ingestUrl = _ingestUrl.replace(/\/+$/, "")

export function getProjectId(): string {
  if (typeof window === "undefined") {
    return "localhost"
  }

  const hostname = window.location.hostname.trim()
  if (hostname.length > 0) {
    return hostname
  }

  return "localhost"
}

/**
 * Checks whether analytics tracking should be disabled for the current user.
 */
export function isTrackingDisabled(): boolean {
  return checkDoNotTrack() || isOptedOut()
}

/**
 * Tracks a privacy-safe custom analytics event.
 */
export function trackAppEvent(name: string, meta?: EventMeta): void {
  if (isTrackingDisabled()) {
    return
  }

  trackEvent(name, meta, { ingestUrl, projectId: getProjectId() })
}
